import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import ReactGA from 'react-ga';

import Routes from './util/Routes';
import registerServiceWorker from './registerServiceWorker';
import injectGlobal from './util/injectGlobal';

// Global styles:
injectGlobal();

// Analytics:
if (process.env.NODE_ENV === 'production') {
  ReactGA.initialize('UA-122395128-1');
  ReactGA.pageview(window.location.pathname);
}

console.log('%cWelcome to Two\'s Complement!', `
  font-size: 22px;
  color: #15779B;
`);

ReactDOM.render(<Routes />, document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js